import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TeamsService } from '../../services/teams.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header-teams',
  templateUrl: './header-teams.component.html',
  styleUrls: ['./header-teams.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderTeamsComponent implements OnInit {
  public selectedTeams: string[];
  public teams: string[];

  constructor(private teamsService: TeamsService, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.teams = this.authService.user.team;
    this.selectedTeams = this.teamsService.teams;
  }

  public onChangeTeams(): void {
    this.teamsService.teams = this.selectedTeams;
  }

  public onToggleTeams(): void {
    if (this.selectedTeams.length > 0) {
      this.selectedTeams = [];
    } else {
      this.selectedTeams = this.teams;
    }

    this.onChangeTeams();
  }

}
